import React, { useEffect, useRef, useState } from "react";

import { TrustpilotContext } from "./contexts";
import type { TrustpilotProviderProps, TrustpilotWindowType } from "./types";

export const TrustpilotProvider: React.FC<TrustpilotProviderProps> = ({
  children,
}) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;

    if ((window as unknown as TrustpilotWindowType).Trustpilot) {
      if (isMounted.current) {
        setScriptLoaded(true);
      }
      return;
    }

    const script = document.createElement("script");
    script.src =
      "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
    script.async = true;
    script.setAttribute("data-testid", "trustpilot-script");

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    script.onload = () => {
      if (isMounted.current) {
        setScriptLoaded(true);
      }
    };

    document.body.appendChild(script);

    return (): void => {
      isMounted.current = false;
    };
  }, []);

  const loadTrustpilot = (elementId: string): void => {
    const windowWithTrustpilot = (window as unknown as TrustpilotWindowType)
      .Trustpilot;

    if (windowWithTrustpilot && document.getElementById(elementId)) {
      windowWithTrustpilot.loadFromElement(
        document.getElementById(elementId),
        true,
      );
    }
  };

  return (
    <TrustpilotContext.Provider value={{ scriptLoaded, loadTrustpilot }}>
      {children}
    </TrustpilotContext.Provider>
  );
};
